export default __webpack_public_path__ + "static/media/gc-white-black@2x.4a713afd.png";